import { render, staticRenderFns } from "./tabbar2.vue?vue&type=template&id=0956e0c4&scoped=true&"
import script from "./tabbar2.vue?vue&type=script&lang=js&"
export * from "./tabbar2.vue?vue&type=script&lang=js&"
import style0 from "./tabbar2.vue?vue&type=style&index=0&id=0956e0c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956e0c4",
  null
  
)

export default component.exports